import React from "react";
import style from "./style/welcome.module.scss"
import library from "../../assets/library.jpg"


const Welcome = () => {
    return (

        <div className={style.main}>
            <div className={style.welcome} style={{ backgroundImage: `url(${library})` }}>
                {/*<img src={library} alt="library"/>*/}
                <div className={style.overlay} />
                {/*<h1>Բարի Գալուստ</h1>*/}
            </div>
            <div className={style.info}>
                <div className={style.hr}/>
                <p>
                    Մանկավարժական գործունեությունն ուսուցչից պահանջում է գիտելիքների, մասնագիտական և
                    փորձարարական կարողությունների անընդհատ բարելավում: Այդ նպատակին է ուղղված ուսուցիչների
                    փորձարարական հմտությունների զարգացման և վերապատրաստման սույն դասընթացը, որը, որպես
                    շարունակական կրթության ապահովման անբաժանելի մաս, կոչված է նպաստելու ներկա կրթական
                    բարեփոխումների իրականացմանը և նրա որակի ու արդյունավետության բարձրացմանը:
                    Հանրակրթական ուսումնական հաստատությունների վերազինումն ու կահավորումը ներկայումս
                    կրթության առաջնահերթություններից է: Դպրոցների մեծ մասում բացակայում են բնագիտական
                    և ինժեներական լաբորատորիաները, իսկ առկա լաբորատորիաները չեն համապատասխանում
                    ժամանակակից կրթության պահանջներին: Այդ նպատակով առաջնահերթ խնդիր է դպրոցներում
                    ժամանակակից նոր լաբորատորիաների հիմնումը և դրանց նպատակային օգտագործումը ուսումնական
                    գործընթացում։
                    Հատկապես նպատակային է բարելավել հանրակրթական դպրոցների ուսուցման և
                    ուսումնառության պայմանները՝ բնագիտական, տեխնոլոգիական, ճարտարագիտական,
                    մաթեմատիկական (ԲՏՃՄ) ոլորտներում. հիմնել նոր լաբորատորիաներ, որոնք հագեցած կլինեն
                    առարկայական վերանայված ծրագրերին և չափորոշիչներին համապատասխանող ժամանակակից
                    բնագիտական և ինժեներական լաբորատոր սարքավորումներով, նյութերով և գույքով, ինչպես նաև
                    անհրաժեշտ համակարգչային սարքավորումներով, որոնք առավել արդյունավետ կդարձնեն
                    լաբորատորիաներում դասավանդման ժամանակակից մեթոդաբանությունների կիրառումը:
                    Կայքում մեծ տեղ է հատկացվել հատկապես հետազոտահեն ուսուցման արդյունավետ
                    պայմանների մշակմանը, սովորողների գործառական և փորձարարական հմտությունների
                    զարգացմանը:
                    Կայքի նյութերը կարող են օգտագործվել որպես ուսումնաօժանդակ նյութեր ուսուցիչների, և բոլոր
                    հետաքրքրված անձանց համար։ Ուշադրություն է դարձվել առարկաների նոր չափորոշիչներով
                    վերջնարդյունքների ապահովմանը միտված գործնական և լաբորատոր աշխատանքների կատարմանը։
                    Յուրաքանչյուր փորձի սկզբում նկարագրված է կապը առարկայական ծրագրի հետ՝ նշելով
                    դասարանը, թեման և վերջնարդյունքը։ Ուսուցիչը, ըստ նպատակահարմարության, նույն փորձը կարող է
                    կիրառել նաև այլ դասարաններում տարբեր թեմաների ուսուցման ժամանակ։
                </p>


            </div>
        </div>

    )
}
export default Welcome